var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.margin)?_c('div',[_vm._v(_vm._s(_vm.renderRemark(_vm.address)))]):_c('span',[_vm._v(_vm._s(_vm.renderRemark(_vm.address)))])}
var staticRenderFns = []

export { render, staticRenderFns }